/*
  Deck-complete: compare cart contents against featured-decks.json,
  surface best-matching archetype with a one-click "add missing cards" action.
  Only activates when overlap >= 50% and there are ≥10 cart line-items.
*/
(() => {
  const widgets = document.querySelectorAll('.deck-complete[data-decks-url]');
  if (!widgets.length) return;

  const MIN_CART_ITEMS = 10;
  const MIN_OVERLAP_PCT = 50;
  const CACHE_KEY = 'inkwell:featured-decks:v1';

  async function loadDecks(url) {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed && Date.now() - parsed.t < 30 * 60 * 1000) return parsed.d;
      }
    } catch (_) { /* ignore */ }
    const r = await fetch(url, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('decks fetch failed');
    const data = await r.json();
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data })); } catch (_) {}
    return data;
  }

  async function loadCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
    if (!r.ok) return null;
    return r.json();
  }

  function extractDecks(data) {
    if (Array.isArray(data)) return data;
    return data.decks || data.archetypes || [];
  }

  function handleFromLine(line) {
    if (line.handle) return line.handle;
    if (line.url) {
      const m = line.url.match(/\/products\/([^?/]+)/);
      if (m) return m[1];
    }
    return null;
  }

  function scoreDeck(deck, cartHandles) {
    const cards = deck.cards || [];
    if (!cards.length) return { overlap: 0, missing: [], matched: [] };
    let matched = [];
    let missing = [];
    cards.forEach(c => {
      if (!c.handle) return;
      if (cartHandles.has(c.handle)) matched.push(c);
      else if (c.matched) missing.push(c);
    });
    const overlapPct = Math.round(100 * matched.length / cards.length);
    return { overlap: overlapPct, missing, matched };
  }

  async function main() {
    let cart;
    try { cart = await loadCart(); } catch (e) { return; }
    if (!cart || !Array.isArray(cart.items)) return;
    const itemCount = cart.items.reduce((n, l) => n + (l.quantity || 0), 0);
    if (itemCount < MIN_CART_ITEMS) return;

    const cartHandles = new Set();
    cart.items.forEach(l => {
      const h = handleFromLine(l);
      if (h) cartHandles.add(h);
    });

    let decks;
    try { decks = extractDecks(await loadDecks(widgets[0].getAttribute('data-decks-url'))); } catch (e) { return; }
    if (!decks.length) return;

    let best = null;
    let bestScore = null;
    decks.forEach(deck => {
      const variants = [deck];
      if (deck.budget_deck) variants.push({ ...deck, cards: deck.budget_deck.cards });
      variants.forEach(variant => {
        const s = scoreDeck(variant, cartHandles);
        if (s.overlap >= MIN_OVERLAP_PCT && (!bestScore || s.overlap > bestScore.overlap)) {
          best = deck; bestScore = s;
        }
      });
    });

    if (!best || !bestScore || !bestScore.missing.length) return;

    const missingHandles = bestScore.missing.map(c => c.handle).filter(Boolean);
    const addUrl = '/cart/add?' + missingHandles.map(h => 'id=' + encodeURIComponent(h)).join('&');

    widgets.forEach(w => {
      const nameEl = w.querySelector('.deck-complete__name');
      const countEl = w.querySelector('.deck-complete__missing');
      const cta = w.querySelector('.deck-complete__cta');
      if (nameEl) nameEl.textContent = best.name || 'a tournament deck';
      if (countEl) countEl.textContent = bestScore.missing.length;
      if (cta) {
        const slug = best.slug || (best.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        cta.href = '/pages/featured-decks' + (slug ? '#' + slug : '');
        cta.textContent = 'View full deck →';
      }
      w.hidden = false;
    });
  }

  main();
})();
